export default "__VITE_ASSET__DZN46o$d__"